import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Calendar, User, Clock, ArrowLeft } from 'lucide-react';
import { blogPosts } from '../data/blogPosts';

const BlogPost = () => {
  const { id } = useParams();
  const post = blogPosts.find((p) => p.id === parseInt(id, 10));

  if (!post) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-400 mb-4">Post não encontrado</h1>
          <Link to="/blog" className="text-[#0B702A] hover:text-[#0C9F39] font-semibold">
            ← Voltar ao blog
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white">
      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-24">
        <Link
          to="/blog"
          className="inline-flex items-center gap-2 text-gray-400 hover:text-[#0B702A] mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Voltar ao blog
        </Link>

        <header className="mb-10">
          <span className="inline-block px-3 py-1 bg-[#0B702A] text-white text-sm font-semibold rounded-full mb-4">
            {post.category}
          </span>
          <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
            {post.title}
          </h1>
          <div className="flex flex-wrap items-center gap-6 text-gray-400 text-sm">
            <div className="flex items-center gap-2">
              <User className="w-4 h-4" />
              <span>{post.author}</span>
            </div>
            <div className="flex items-center gap-2">
              <Calendar className="w-4 h-4" />
              <span>{new Date(post.date).toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' })}</span>
            </div>
            <div className="flex items-center gap-2">
              <Clock className="w-4 h-4" />
              <span>{post.readTime}</span>
            </div>
          </div>
        </header>

        <div className="relative rounded-xl overflow-hidden mb-12 h-64 md:h-96">
          <img
            src={post.image}
            alt={post.title}
            className="w-full h-full object-cover"
          />
        </div>

        <div className="prose prose-invert prose-lg max-w-none">
          {post.content && post.content.map((paragraph, index) => (
            <p key={index} className="text-gray-300 leading-relaxed mb-6">
              {paragraph}
            </p>
          ))}
        </div>

        {post.tags && post.tags.length > 0 && (
          <div className="mt-12 pt-8 border-t border-[#0B702A]/20">
            <span className="text-sm text-gray-500 mr-2">Tags:</span>
            {post.tags.map((tag) => (
              <span
                key={tag}
                className="inline-block px-3 py-1 bg-[#014421]/50 text-gray-400 text-sm rounded mr-2 mb-2"
              >
                {tag}
              </span>
            ))}
          </div>
        )}

        <div className="mt-12">
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 text-[#0B702A] hover:text-[#0C9F39] font-semibold transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Voltar ao blog
          </Link>
        </div>
      </article>
    </div>
  );
};

export default BlogPost;
